import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { Logo } from "@/components/Logo";
import { toast } from "sonner";

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Hoş geldiniz!");
      nav("/");
    } catch (err) { toast.error(err.response?.data?.detail || "Giriş başarısız"); }
    finally { setLoading(false); }
  };

  return (
    <div className="min-h-[80vh] flex items-center justify-center px-4">
      <form data-testid="login-form" onSubmit={submit} className="bg-white border border-gray-100 rounded-lg p-8 shadow-sm w-full max-w-md">
        <div className="flex justify-center mb-5"><Logo size="lg" /></div>
        <h1 className="text-2xl font-black text-center mb-1">Giriş Yap</h1>
        <p className="text-sm text-gray-500 text-center mb-6">81 İlden Tek Gerçeğe hoş geldiniz</p>
        <label className="block text-sm font-medium mb-1">Email</label>
        <input data-testid="login-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="w-full px-3 py-2 border border-gray-200 rounded-md text-sm mb-3" />
        <label className="block text-sm font-medium mb-1">Şifre</label>
        <input data-testid="login-password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} className="w-full px-3 py-2 border border-gray-200 rounded-md text-sm mb-4" />
        <button data-testid="login-submit" type="submit" disabled={loading} className="w-full px-4 py-2.5 bg-[#e11d2a] text-white rounded-md font-semibold hover:bg-[#b8161f]">{loading ? "Giriş yapılıyor..." : "Giriş Yap"}</button>
        <div className="mt-3 text-sm text-center"><Link to="/sifremi-unuttum" className="text-gray-600 hover:text-[#e11d2a]">Şifremi unuttum</Link></div>
        <div className="mt-4 text-sm text-center">Hesabınız yok mu? <Link to="/kayit" className="text-[#e11d2a] font-semibold">Üye Ol</Link></div>
      </form>
    </div>
  );
}
